import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import ToastService from 'primevue/toastservice';
import Aura from '@primevue/themes/aura'
import './app.scss'
import router from "./router";
import App from "./App.vue";
import {  Toast } from "primevue";
import Card from 'primevue/card';
import ProgressSpinner from 'primevue/progressspinner';
import ConfirmationService from 'primevue/confirmationservice'; // Importando o serviço de confirmação
import ConfirmDialog from 'primevue/confirmdialog'; // Importando o componente de diálogo

const app = createApp(App);
app.use(createPinia());
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
        prefix: 'p',
        // darkModeSelector: 'system',
        // defaultTheme: "light",
        darkModeSelector : '.fake-dark-selector',
        ripple: true,
        // cssLayer: false
        cssLayer: {
          name: 'primevue',
          // Enable PrimeVue CSS layer and configure the tailwind styles to have higher specificity with layering
          order: 'tailwind-base, primevue, tailwind-utilities',
      },
    }
  },
});
app.use(ToastService);
app.component("Toast", Toast);
app.component("Progress", ProgressSpinner);
app.use(ConfirmationService);
app.component("ConfirmDialog", ConfirmDialog);
app.component("Card", Card);

app.use(router);
app.mount("#app");
